import { Link } from "react-router-dom";
import { useLang, pickLocalized } from "@/contexts/LangContext";

export default function ProductCard({ product }) {
  const { lang } = useLang();
  const name = pickLocalized(product, lang, "name");
  const image = (product.images || [])[0];
  return (
    <Link
      to={`/producto/${product.slug}`}
      className="block group fade-in"
      data-testid={`product-card-${product.slug}`}
    >
      <div className="product-image-wrap aspect-[4/5] bg-[#efece8]">
        {image ? (
          <img src={image} alt={name} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-[var(--eafg-muted)] tracking-eyebrow">
            sin imagen
          </div>
        )}
      </div>
      <div className="mt-5 flex items-start justify-between gap-4">
        <div>
          <h3 className="font-serif-display text-2xl leading-none">{name}</h3>
          <p className="tracking-eyebrow text-[var(--eafg-muted)] mt-2">
            {lang === "es" ? "Pieza única" : "One of a kind"}
          </p>
        </div>
        <div className="text-right">
          <span className="text-base">{Number(product.price).toFixed(2)} €</span>
        </div>
      </div>
    </Link>
  );
}
